module.exports = __webpack_public_path__ + "static/media/mipf.03834739.png";